<template>
  <div class="animated fadeIn liquidacion-sueldos-pago">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card>
            <b-form-group
              label="Periodo"
              label-for="periodo"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="periodo" 
                v-model="periodoLiquidacion" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Total"
              label-for="totalLiquidacion"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="totalLiquidacion" 
                :value="totalLiquidacion | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <app-caja
              label="Caja"
              :label-cols="labelCols"
              :nombre="cajaRegistroNombre"
              :valido="cajaRegistroValida"
              :lista="cajasRegistrosList"
              :msjInvalido="cajaRegistroInvalidaMsj"
              @validate="validate"
              @updated="cajaRegistroActualizada">
            </app-caja>  
          </b-card>

          <b-card>
            <b-row>
              <b-col cols="6">
                <b-form-group
                  label="Pesos"
                  label-for="pesos"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="pesos"
                    v-model.trim="$v.pesos.$model" 
                    :state="pesosValido"
                    type="text"
                    @blur.native="validarPago">
                  </b-form-input>
                  <b-form-invalid-feedback id="pesosFeedback">
                    {{ pesosInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Cheques Propios"
                  label-for="chequesPropios"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-input-group>
                    <b-input-group-append 
                        class="filter-search-icons" 
                        @click="agregarChequePropio">
                      <b-input-group-text>
                        <i class="fa fa-plus"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                    <b-form-input 
                      id="chequesPropios"
                      :value="importeChequesPropios | moneda"
                      :readonly="Boolean(true)">
                    </b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-table 
                    v-if="chequesPropios.length != 0"
                    hover
                    responsive="sm" 
                    class="pagos-documentos"
                    :busy="tableBusy"
                    :items="chequesPropios" 
                    :fields="chequesPropiosFields">

                  <template v-slot:cell(fechaCreditoDebito)="data">
                    {{ data.item.fechaCreditoDebito | fecha }}
                  </template>
                  <template v-slot:cell(importe)="data">
                    {{ data.item.importe | moneda }}
                  </template>
                  <template v-slot:cell(borrar)="data">
                    <i class="fa fa-remove" @click.stop="borrarChequePropio(data.item)"></i>
                  </template>
                </b-table>

                <b-form-group
                  label="Transferencias"
                  label-for="transferencias"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-input-group>
                    <b-input-group-append 
                        class="filter-search-icons" 
                        @click="agregarTransferencia">
                      <b-input-group-text>
                        <i class="fa fa-plus"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                    <b-form-input 
                      id="transferencias"
                      :value="importeTransferencias | moneda"
                      :readonly="Boolean(true)">
                    </b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-table 
                    v-if="transferencias.length != 0"
                    hover
                    responsive="sm" 
                    class="pagos-documentos"
                    :busy="tableBusy"
                    :items="transferencias" 
                    :fields="transferenciasFields">

                  <template v-slot:cell(fechaCreditoDebito)="data">
                    {{ data.item.fechaCreditoDebito | fecha }}
                  </template>
                  <template v-slot:cell(importe)="data">
                    {{ data.item.importe | moneda }}
                  </template>
                  <template v-slot:cell(borrar)="data">
                    <i class="fa fa-remove" @click.stop="borrarTransferencia(data.item)"></i>
                  </template>
                </b-table>
              </b-col>
              <b-col cols="6">
                <b-form-group
                  label="Total Documentos"
                  label-for="totalDocumentos"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="totalDocumentos"
                    :value="totalDocumentos | moneda"
                    :readonly="Boolean(true)">
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Saldo"
                  label-for="saldo"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="saldo"
                    :value="saldo | moneda"
                    :readonly="Boolean(true)">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <b-modal ref="addChequePropioModal" 
        title="Cheques Propios"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-cheque-propio
        @chequePropioActualizado="chequePropioActualizado"
        @cancel="closeChequePropio">
      </app-cheque-propio>
    </b-modal>

    <b-modal ref="addTransferenciaModal" 
        title="Transferencias Bancarias"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-transferencia
        @transferenciaAgregada="transferenciaAgregada"
        @cancel="transferenciaCancelada">
      </app-transferencia>
    </b-modal>
  </div>
</template>

<script>
import { decimal, minValue } from 'vuelidate/lib/validators';
import Caja from '../shared/abmSelect.vue';
import ChequePropio from '../chequespropios/ABM.vue'
import Transferencia from '../bancosmovimientos/Movimiento.vue'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'liquidacionSueldosPagos/getField',
  mutationType: 'liquidacionSueldosPagos/updateField',
});

export default {
  name: 'ABM',
  components: {
    appCaja: Caja,
    appChequePropio: ChequePropio,
    appTransferencia: Transferencia,
  },
  data () {
    return {
      noValidar: true,
      cajaRegistroValida: null,
      cajaRegistroInvalidaMsj: '',
      pesosValido: null,
      pesosInvalidoMsj: '',

      chequesPropiosFields: [
        { 
          key: 'fechaCreditoDebito',
          label: 'Fecha Pago'
        },
        { 
          key: 'numero',
          label: 'Numero'
        },
        { key: 'importe' },
        { 
          key: 'borrar',
          label: '',
          class: 'table-remove-icon' 
        },
      ],

      transferenciasFields: [
        { 
          key: 'fechaCreditoDebito',
          label: 'Fecha'
        },
        { 
          key: 'bancoCuentaNombre',
          label: 'Cuenta'
        },
        { key: 'importe' },
        { 
          key: 'borrar',
          label: '',
          class: 'table-remove-icon' 
        },
      ],


      labelCols: 2,
      cajasRegistros: [],
      cajasRegistrosList: [],
      tableBusy: false
    }
  },
  computed: {
    ...mapFields([
      'periodo',
      'totalLiquidacion',
      
      'cajaRegistro',
      'cajaRegistroNombre',
      'pesos',
      'importeChequesPropios',
      'chequesPropios',
      'importeTransferencias',
      'transferencias',
    ]),
    periodoLiquidacion() {
      if (this.periodo) {
        return this.$options.filters.periodo(this.periodo);
      }
      return '';
    },
    totalDocumentos() {
      return parseFloat(this.pesos) 
        + parseFloat(this.importeChequesPropios)
        + parseFloat(this.importeTransferencias);
    },
    saldo() {
      return parseFloat(this.totalLiquidacion) - parseFloat(this.totalDocumentos);
    }
  },
  created() {
    
  },  
  activated() {
    this.getDatosAdicionales();
    this.validarPago();
  },
  methods: {
    getDatosAdicionales() {
      let vm = this;
      vm.$store.dispatch('cajasregistros/getCajasRegistrosSelect')
        .then(() => {
          vm.cajasRegistros = this.$store.getters['cajasregistros/cajasRegistrosSelect'];
          vm.cajasRegistrosList = this.$store.getters['cajasregistros/cajasRegistrosSelectList'];
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de cajas.'));
    },

    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'pesos' || validarTodos) {
        this.pesosValido = null;
        this.pesosInvalidoMsj = this.displayErrorMonto (this.$v.pesos.$error, 
          this.$v.pesos.decimal, this.$v.pesos.minValue); 
        
        if (this.pesosInvalidoMsj.trim() != '') {
          this.pesosValido = false;
        }

        // this.validarPago();
      }
    },
    displayErrorMonto( fieldError, fieldErrorDecimal, fieldErrorMinValue) {
      let errorMsj = '';
      if (fieldError) {
        if (fieldErrorDecimal) {
          errorMsj = 'El monto ingresado debe ser un valor numérico';
        } else if (fieldErrorMinValue) {
          errorMsj = 'El monto ingresado no es válido';
        }
      }
      return errorMsj;
    },
    validarPago() {
      let isValid = true;
      
      if (this.totalDocumentos == 0) {
        isValid = false;
      }

      if (this.$v.pesos.$error) {
        isValid = false;
      }

      this.displayErrores();

      if (this.cajasRegistros) {
        if (this.cajasRegistros.length != 0) {
          let cajaRegistro;
          if (this.cajaRegistroNombre) {
            cajaRegistro = this.getSelected(this.cajasRegistros, this.cajaRegistroNombre);
          }
          this.$store.dispatch('liquidacionSueldosPagos/setCajaRegistro', cajaRegistro);

          if (this.cajaRegistro) {
            if (this.cajaRegistro.id == 0){
              isValid = false;
              this.cajaRegistroValida = false;
              this.cajaRegistroInvalidaMsj = 'Debe seleccionar la caja correspondiente.';
            }
          } else {
            isValid = false;
            this.cajaRegistroValida = false;
            this.cajaRegistroInvalidaMsj = 'Debe seleccionar la caja correspondiente.';
          }
        } else {
          isValid = false;
        }
      } else {
        isValid = false;
      }


      if ((/true/i).test(isValid)) {
        this.$emit('can-continue', { value: true });
      } else {
        this.$emit('can-continue', { value: false });
      }
    },

    cajaRegistroActualizada(nombre) {
      this.cajaRegistroNombre = nombre;
      this.validarPago();
    },
    agregarChequePropio(){
      this.$refs.addChequePropioModal.show();
    },
    chequePropioActualizado(chequePropio){
      this.$refs.addChequePropioModal.hide();
      this.showSpinner();
      this.$store.dispatch('liquidacionSueldosPagos/setChequePropio', chequePropio)
        .then (() => this.validarPago())
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    closeChequePropio(){
      this.$refs.addChequePropioModal.hide();
    },
    borrarChequePropio(item){
      this.showSpinner();
      this.$store.dispatch('liquidacionSueldosPagos/deleteChequePropio', item)
        .then (() => this.validarPago())
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },

    agregarTransferencia(){
      this.$refs.addTransferenciaModal.show();
    },
    transferenciaAgregada(transferencia){
      this.$refs.addTransferenciaModal.hide();
      this.showSpinner();
      this.$store.dispatch('liquidacionSueldosPagos/setTransferencia', transferencia)
        .then (() => this.validarPago())
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    transferenciaCancelada(){
      this.$refs.addTransferenciaModal.hide();
    },
    borrarTransferencia(item){
      this.showSpinner();
      this.$store.dispatch('liquidacionSueldosPagos/deleteTransferencia', item)
        .then (() => this.validarPago())
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },

  },
  validations: {
    pesos: { 
      decimal,
      minValue: minValue(0)
    }
  },  
  watch: {
  },
}
</script>

<style>
  /* .liquidacion-sueldos-pago div#pagoEfectivo > div:nth-child(2) {
    margin-bottom: 30px !important;
  }
  .liquidacion-sueldos-pago div.custom-radio {
    margin-bottom: 10px;
  } */
  .liquidacion-sueldos-pago .opcion-pago {
    margin-top: 40px;
    margin-bottom: 10px;
  }

</style>
